import DealershipFamily from './DealershipFamily';

// TODO: If this list grows, consider loading this from a service
const dealershipFamilyMap: Record<string, DealershipFamily> = {
  'atl-cdjr-new': DealershipFamily.Cdjr,
  'bos-cdjr-new': DealershipFamily.Cdjr,
  'casd-cdjr-new': DealershipFamily.Cdjr,
  'cg-cdjr-new': DealershipFamily.Cdjr,
  'cle-cdjr-new': DealershipFamily.Cdjr,
  'dal-cdjr-new': DealershipFamily.Cdjr,
  'sac-cdjr-new': DealershipFamily.Cdjr
};

export default dealershipFamilyMap;
